var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGymLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 522,
    height: 358,
    viewBox: "0 0 522 358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E9530D",
    strokeWidth: 10,
    d: "M38.616 142C19.751 143.982 5 159.983 5 179.36c0 19.743 15.306 35.976 34.674 37.46.956.072.242-74.956-1.058-74.82zM484.051 216.428c18.393-2.423 32.637-18.202 32.637-37.247 0-18.881-14.005-34.556-32.173-37.18-1.762-.255-2.078 74.64-.464 74.427zM153 141h215.592v70.673H153z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9530D",
    strokeWidth: 10,
    d: "M197 141h127.826v70.673H197z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#E9530D",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.657 57.819H51.049c-6.35 0-11.495 5.17-11.495 11.54v218.92c0 6.375 5.145 11.54 11.495 11.54h33.667M440.404 299.819h31.357c6.349 0 11.495-5.165 11.495-11.54V69.358c0-6.37-5.146-11.54-11.495-11.54h-31.553"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#E9530D",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.338 5.674h-47.114c-6.32 0-11.444 5.18-11.444 11.57v323.86c0 6.39 5.125 11.57 11.444 11.57h47.114c6.32 0 11.442-5.18 11.442-11.57V17.244c0-6.39-5.123-11.57-11.442-11.57zM141.075 5.674H93.96c-6.32 0-11.443 5.18-11.443 11.57v323.86c0 6.39 5.123 11.57 11.443 11.57h47.115c6.318 0 11.442-5.18 11.442-11.57V17.244c0-6.39-5.124-11.57-11.442-11.57z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGymLine);
export default __webpack_public_path__ + "static/media/gym-line.f8d3a1a51185aff0cc150204a5305f24.svg";
export { ForwardRef as ReactComponent };